import './FridgePage.scss'
import {useEffect, useRef, useState} from "react";
import sausages from '../assets/products/sausages.png'
import cheese from '../assets/products/cheese.png'
import dory from '../assets/products/dory.png'
import salami from '../assets/products/salami.png'
import jam from '../assets/products/jem.png'
import flakes from '../assets/products/flakes.png'
import banana from '../assets/products/banana.png'
import tomato from '../assets/products/tomato.png'
import papper from '../assets/products/papper.png'
import peach from '../assets/products/peach.png'
import spickers from '../assets/products/spickers.png'
import cheescacke from '../assets/products/cheescacke.png'
import egg from '../assets/products/egg.png'
import milk from '../assets/products/milk.png'
import energy from '../assets/products/energy.png'
import focus from '../assets/products/focus.png'
import cola from '../assets/products/cola.png'
import {makeImagesNotDraggable} from "../../utilites/img-ut";
import open from "../../sounds/open.mp3";
import close from "../../sounds/close.mp3";
import jevanie from "../../sounds/jevanie.mp3";
import trash from "../../sounds/trash.mp3";
import {t} from "i18next";

const onCheckProduct = (products, id) => {
  let isHidden = ""
  const product = products.find(it=> it.id === id)
  if (!product) {
    return isHidden = " hidden"
  }
  if (product.pieces === 0) {
    return isHidden = " hidden"
  }
  if (product.onTrash === true) {
    return isHidden = " hidden"
  }

  return isHidden
}

const isCheckHard = (currentDeadline, currentDay) => {
  if(currentDay === 8) {
    return true
  }
  if(currentDeadline === 3) {
    return true
  }

  return currentDeadline === 5 && currentDay < 10;

}

const isCheckProductsEnd = (products) => {
  const allOnTrashOrZeroPieces = products.every(item => item.onTrash || item.pieces === 0);
  return allOnTrashOrZeroPieces ? true : false
}

const FridgePage = (props) => {
  const {
    onChangeView,
    currentDay,
    currentDeadline,
    setCurrentFatigue,
    setProducts,
    setCurrentHunger,
    products,
    setFoodPoisoning,
    soundsFX,
    soundsRef,
  } = props

  const [chosenItem, setChosenItem] = useState(null)

  const wrapperRef = useRef()
  useEffect(()=>{
    makeImagesNotDraggable(wrapperRef)
  }, [])

  useEffect(() => {
    soundsFX.onPlay(open, false,false, soundsRef)
  }, []);

  const onChoseItem = (id) => {
    setChosenItem(products.find(it=> it.id === id))
    }

  const onEatItem = (id) => {
    if(id === 'energy') {
      setCurrentFatigue(prevState => prevState - 60 >= 0 ? prevState - 60 : 0)
    }

    const item = products.find(it=> it.id === id)
    setChosenItem(false)
    const updatedProducts = products.map(product => {
      if (product.id === id) {
        return { ...product, pieces: item.pieces - 1 };
      }
      return product;
    });
    setProducts(updatedProducts);
    setCurrentHunger(prevState => prevState - item.value >= 0 ? prevState - item.value : 0 )
    soundsFX.onPlay(jevanie, false,false, soundsRef)

    const isOutdated = currentDay - 8 > item.days
    if(isOutdated) {
      setFoodPoisoning(true)
      onChangeView("BedroomPage")
    }
  }

  const onMoveToTrashItem = (id) => {
    setChosenItem(false)
    const updatedProducts = products.map(product => {
      if (product.id === id) {
        return { ...product, onTrash: true };
      }
      return product;
    });
    soundsFX.onPlay(trash, false,false, soundsRef)
    setProducts(updatedProducts);
  }



  return <div className="FridgePage" ref={wrapperRef}>
    <div className="products-layer">
      <div className={"cells cheese" + onCheckProduct(products,'cheese')}>
        <button className="" onClick={()=>onChoseItem('cheese')}><img src={cheese} /></button>
      </div>
      <div className={"cells dory" + onCheckProduct(products,'dory')}>
        <button className="" onClick={()=>onChoseItem('dory')}><img src={dory} /></button>
      </div>
      <div className={"cells dory2" + onCheckProduct(products,'dory2')}>
        <button className="" onClick={()=>onChoseItem('dory2')}><img src={dory} /></button>
      </div>
      <div className={"cells salami" + onCheckProduct(products,'salami')}>
        <button className="" onClick={()=>onChoseItem('salami')}><img src={salami} /></button>
      </div>
      <div className={"cells sausages" + onCheckProduct(products,'sausages')}>
        <button className="" onClick={()=>onChoseItem('sausages')}><img src={sausages} /></button>
      </div>
      <div className={"cells jam" + onCheckProduct(products,'jam')}>
        <button className="" onClick={()=>onChoseItem('jam')}><img src={jam} /></button>
      </div>
      <div className={"cells flakes" + onCheckProduct(products,'flakes')}>
        <button className="" onClick={()=>onChoseItem('flakes')}><img src={flakes} /></button>
      </div>
      <div className={"cells banana" + onCheckProduct(products,'banana')}>
        <button className="" onClick={()=>onChoseItem('banana')}><img src={banana} /></button>
      </div>
      <div className={"cells tomato" + onCheckProduct(products,'tomato')}>
        <button className="" onClick={()=>onChoseItem('tomato')}><img src={tomato} /></button>
      </div>
      <div className={"cells paper" + onCheckProduct(products,'paper')}>
        <button className="" onClick={()=>onChoseItem('paper')}><img src={papper} /></button>
      </div>
      <div className={"cells peach" + onCheckProduct(products,'peach')}>
        <button className="" onClick={()=>onChoseItem('peach')}><img src={peach} /></button>
      </div>
      <div className={"cells spickers" + onCheckProduct(products,'spickers')}>
        <button className="" onClick={()=>onChoseItem('spickers')}><img src={spickers} /></button>
      </div>
      <div className={"cells cheescacke" + onCheckProduct(products,'cheescacke')}>
        <button className="" onClick={()=>onChoseItem('cheescacke')}><img src={cheescacke} /></button>
      </div>
      <div className={"cells egg" + onCheckProduct(products,'egg')}>
        <button className="" onClick={()=>onChoseItem('egg')}><img src={egg} /></button>
      </div>
      <div className={"cells egg2" + onCheckProduct(products,'egg2')}>
        <button className="" onClick={()=>onChoseItem('egg2')}><img src={egg} /></button>
      </div>
      <div className={"cells milk" + onCheckProduct(products,'milk')}>
        <button className="" onClick={()=>onChoseItem('milk')}><img src={milk} /></button>
      </div>
      <div className={"cells energy" + onCheckProduct(products,'energy')}>
        <button className="" onClick={()=>onChoseItem('energy')}><img src={energy} /></button>
      </div>
      <div className={"cells focus" + onCheckProduct(products,'focus')}>
        <button className="" onClick={()=>onChoseItem('focus')}><img src={focus} /></button>
      </div>
      <div className={"cells cola" + onCheckProduct(products,'cola')}>
        <button className="" onClick={()=>onChoseItem('cola')}><img src={cola} /></button>
      </div>
    </div>
    <div className="glass" />

    {chosenItem && <div className="panel-info">
      <div>{t('fridge-its')} {t(`products.${chosenItem.id}`)}</div>
      <div className="img"><img src={chosenItem.src} /></div>
      <div className="pice">{t('fridge-Pieces')} {chosenItem.pieces}</div>
      {(isCheckHard(currentDeadline, currentDay)) && <div className="pice">{t('fridge-ProductFresh')} {chosenItem.days} {t('fridge-days')}</div>}
      <div className="pice">{t('fridge-FoodValue')} {chosenItem.value}</div>
      <div className='eat-btns'>
        <button className="eat-btn" onClick={()=>onEatItem(chosenItem.id)}>{t('fridge-use')} </button>
        <button className="eat-btn" onClick={()=>onMoveToTrashItem(chosenItem.id)}>{t('fridge-trash')}</button>
      </div>
    </div>}

    {isCheckProductsEnd(products) && <>
      <div className="notification">
        {t('fridge-empty')} <span className="link" onClick={() => onChangeView("NewGamePage")}>{t('fridge-newJam')}</span>
      </div>
      <div className="mouse" />
    </>}

    <button className="back-button-fr" onClick={()=> {
      soundsFX.onPlay(close, false,false, soundsRef)
      onChangeView("KitchenPage")
    }}>{t('fridge-Close')}</button>
  </div>
}

export default FridgePage